import { render, staticRenderFns } from "./ClassificationDegreeCards.vue?vue&type=template&id=5a9d12a9&"
import script from "./ClassificationDegreeCards.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegreeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports